module.exports = __webpack_public_path__ + "img/bolivia.9c97089b.svg";